﻿export function initSite() {

    let lastActivated = '';
    function ActivateTab(id) {
        if (!lastActivated.includes(id)) {
            lastActivated = id.includes('small') ? id.substring(5) : id;
            let name = id.includes('small') ? '#' + id.substring(5) : '#small' + id;
            $(name).click();
            window.scrollTo(0, 0);
        }
    }
    function menuToggle() {
        document.getElementById("menuDropdownContainer").classList.toggle("show");
    }

    
    $('.goback').on('click', function () {
        GoBack();
    });


    function GoBack() {
        window.history.back()
    }

    // Handle changes in the color scheme
    const handleColorSchemeChange = (event) => {
        if (event.matches) {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }
    };

    // change system theme trigger this function
    // Add event listener for changes in the color scheme
    if (window.matchMedia) {
        const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches

        if (isDarkMode) {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }

        const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        darkModeMediaQuery.addEventListener('change', handleColorSchemeChange);
    } else {
        console.warn("window.matchMedia is not supported on this browser.");
    }

    function menuToggle() {
        document.getElementById("mobileMainMenu").classList.toggle("hide");
    }

    $('#mainMenuToggleButton').on('click', function () {
        menuToggle();
    });

}